import deleteParameterConfigReducer from './actions/deleteParameterConfigSlice';
import { configureStore } from '@reduxjs/toolkit';
import apiSlice from './actions/apiSlice';
import dashboardTitle from './actions/dashboardTitle';
import userTypeSlice from './actions/userTypeSlice';
import afcSummarySlice from './actions/afcSummarySlice';
import afcFiltersSlice from './actions/afcFiltersSlice';
import afcRiskCountSlice from './actions/afcRiskCountSlice';
import supplierSummarySlice from './actions/supplierSummarySlice';
import supplyDrilldownSlice from './actions/supplyDrilldownSlice';
import purchaseRequisitionSlice from './actions/purchaseRequisitionSlice';
import afcAnalysisSlice from './actions/afcAnalysisSlice';
import parameterConfigReducer from './actions/parameterConfigSlice';
import updateParameterConfigReducer from './actions/updateParameterConfigSlice';
import updateRiskConfigReducer from './actions/updateRiskConfigSlice';
import activeGlobalRiskConfigReducer from './actions/activeGlobalRiskConfigSlice';
import globalParamFilterReducer from './actions/globalParamFilterSlice';
import activeParameterConfigReducer from './actions/activeParameterConfigSlice';
import parameterOverrideReducer from './actions/parameterOverrideSlice';
import supplierConfirmationReducer from './actions/supplierConfirmationSlice';
import sapIbpSyncStatusReducer from './actions/sapIbpSyncStatusSlice';
import userDefinedRiskStatusReducer from './actions/userDefinedRiskStatusSlice';
import userSupportTicketReducer from './actions/userSupportTicketSlice';
import getUserSupportTicketSummaryReducer from './actions/getUserSupportTicketSummarySlice';
import NewVariantSliceReducer from './actions/VariantView/NewVariantSlice';
import EditVariantSliceReducer from './actions/VariantView/EditVariantSlice';
import GetVariantsListSliceReducer from './actions/VariantView/GetVariantsListSlice';
import DeleteVariantSliceReducer from './actions/VariantView/DeleteVariantSlice';
import ShareVariantSliceReducer from './actions/VariantView/ShareVariantSlice';
import ShareVariantUsersSliceReducer from './actions/VariantView/ShareVariantUsersSlice';
export const store = configureStore({
  reducer: {
    apiData: apiSlice,
    dashboardDetails: dashboardTitle,
    userCardType: userTypeSlice,
    afcSummary: afcSummarySlice,
    afcFilters: afcFiltersSlice,
    afcRiskCount: afcRiskCountSlice,
    supplierSummary: supplierSummarySlice,
    supplyDrilldown: supplyDrilldownSlice,
    purchaseRequisition: purchaseRequisitionSlice,
    afcAnalysis: afcAnalysisSlice,
    parameterConfig: parameterConfigReducer,
    updateParameterConfig: updateParameterConfigReducer,
    updateRiskConfig: updateRiskConfigReducer,
    activeGlobalRiskConfig: activeGlobalRiskConfigReducer,
    deleteParameterConfig: deleteParameterConfigReducer,
    globalParamFilter: globalParamFilterReducer,
    activeParameterConfig: activeParameterConfigReducer,
    parameterOverride: parameterOverrideReducer,
    supplierConfirmation: supplierConfirmationReducer,
    sapIbpSyncStatus: sapIbpSyncStatusReducer,
    userDefinedRiskStatus: userDefinedRiskStatusReducer,
    userSupportTicket: userSupportTicketReducer,
    getUserSupportTicketSummary: getUserSupportTicketSummaryReducer,
    NewVariantSlice: NewVariantSliceReducer,
    EditVariantSlice: EditVariantSliceReducer,
    GetVariantsListSlice: GetVariantsListSliceReducer,
    DeleteVariantSlice: DeleteVariantSliceReducer,
    ShareVariantSlice: ShareVariantSliceReducer,
    ShareVariantUsersSlice: ShareVariantUsersSliceReducer,
    },
  })